import React from "react"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Content from "./Content/Content";
import Header from "./Header";
import Support from "./Support/Support.jsx";
import NewSite from "./NewSite";

function App() {
  return (
    <div style={{ overflow: "hidden" }}>
      <Router>
        <Switch>

          <Route path="/dataentry">
            <Support />
          </Route>
          <Route path="/editproperty">
            <Support />
          </Route>

          <Route path="/NewSite">
            <NewSite />
          </Route>

          <Route path="/">
            <Header />
            <Content />
          </Route>

        </Switch>
      </Router>
    </div>
  );
}

export default App;